import { transform } from "ol/proj";
import { store } from "../../../../../stateManagement/store";
import { setMapTooltipInfoCopied, setMapTooltipKm, setMapTooltipPathName, setMapTooltipRoadName, setMapTooltipIsVisible, setMapTooltipIsLoading, setMapTooltipData, resetMapTooltipData } from "../../../../../stateManagement/reducers/MapTooltipSlice";
import { findMaxEventYearFeature } from "../../helpers";
import { transformObjectWithEnums } from "../../../../../features/dataFormatFunctions/dataFormatter";
import { featurePropsForMapTooltip, getFeatureURLParamsObject } from "../getObjectsOnMapPoint/getObjectsOnMapPoint";
import { getItemWebStorage } from "../../../../../features/webStorageSaver";
import { fetchCoordsToPosition } from "../../../../../api/mapApi";
import type TileLayer from "ol/layer/Tile";
import type { TileWMS } from "ol/source";
import { shortMeasureTypesNames } from "../../../../diagnostics/diagnosticsPathNormativitiesSection";
import { roadCategoryFiltersOptions } from "../../../mapAddons/mapOverlayWidget/roadCategorySegmentsOverlay";
import { showToastMessage } from "../../../../../stateManagement/reducers";
import { formatObject } from "src/features/dataFormatFunctions/formatObject";
import { roadBedFiltersOptions } from "src/widgets/map/mapAddons/mapOverlayWidget/roadBedLayerSegmentsOverlay";

let cursorTimer: any;
const currentConfig = getItemWebStorage('currentConfig')
const { wmsVersion } = currentConfig ?? {}

async function getSegmentNormativityBounds(segmentNormativityId: any, pathNormativityId: any, measureType: any, chosenMapMultipleMeasureTypes: any) {
    let apiUrl = currentConfig?.irosRestApiUrl
    const token = store.getState().auth.tokens.app
    let url
    if (measureType) {
        url = `${apiUrl}/diagnostics/segmentNormativityBounds?SegmentNormativityId=${segmentNormativityId}&PathNormativityId=${pathNormativityId}&${measureType}=true`;
    } else {
        let filterMeasures = ''
        Object.keys(chosenMapMultipleMeasureTypes).map(measure => {
            if (chosenMapMultipleMeasureTypes[measure]) {
                filterMeasures += `&${measure}=true`
            }
        })
        url = `${apiUrl}/diagnostics/segmentNormativityBounds?SegmentNormativityId=${segmentNormativityId}&PathNormativityId=${pathNormativityId}` + filterMeasures;
    }
    try {
        const response: any = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (response.ok) {
            const data = await response.json();
            const { StartKm, EndKm } = data ?? {}
            if (StartKm != null && EndKm != null) {
                // сохраняем числовые значения в data → UI сам отформатирует
                const start = Number(StartKm);
                const end = Number(EndKm);
                if (!Number.isNaN(start) && !Number.isNaN(end)) {
                    return { Position: start, Ending: end }
                }
            }
        }
    } catch (error) {

    }
}

export async function showMapTooltip(event: any, type: any, layer: TileLayer<TileWMS>, map: any, measureType?: any) {
    const { pathNormativitiesMapMultipleMeasureTypes: mapMultipleMeasureTypes, pathNormativitiesMapNormativityFlag: mapNormativityFlag, pathNormativitiesMapYearFilter: chosenYearFromPathNormativities } = store.getState().diagnosticsPathNormativities
    let layersNames = layer?.getSource()?.getParams()?.LAYERS
    let cqlFilter = layer?.getSource()?.getParams()?.CQL_FILTER
    let styles = layer?.getSource()?.getParams()?.STYLES
    clearTimeout(cursorTimer); // Очищаем предыдущий таймер при каждом вызове функции
    cursorTimer = setTimeout(async () => { // Устанавливаем новый таймер
        store.dispatch(setMapTooltipIsLoading(true))
        let kmOffset
        if (type !== 'RoadAccidents') {
            try {
                const eventCoords = transform(event.coordinate, 'EPSG:3857', 'EPSG:4326')
                const actualRoadQuery = await fetchCoordsToPosition('0', '0', eventCoords[1], eventCoords[0])
                kmOffset = actualRoadQuery?.Offset
                store.dispatch(setMapTooltipKm(actualRoadQuery?.ProjectPosition?.replace('.', ',')))
                store.dispatch(setMapTooltipRoadName(actualRoadQuery?.RoadName))
                store.dispatch(setMapTooltipPathName(actualRoadQuery?.PathName))
            } catch {
                store.dispatch(showToastMessage({ messageText: 'В заданной позиции дорога не найдена', messageType: "error", windowType: "map" }))
            }
        }
        let layerURL: any
        let propsType = type
        if (type === 'RoadAccidents' || Math.abs(parseFloat(kmOffset)) < 200) {
            if (type === 'pathNormativities') {
                layerURL = 'MADiagSegmentNormativity'
                if (measureType) {
                    propsType = 'pathNormativities' + measureType
                }
                if (!measureType) {
                    propsType = 'pathNormativitiesGroup'
                    const filtersArray = Object.entries(mapMultipleMeasureTypes)
                        .filter(([key, value]) => value === true)
                        .map(([key, value]) => `${key}=${mapNormativityFlag ? 1 : 0}`)
                        ?.join(' and ');
                    cqlFilter = `DiagnosticYear in (${chosenYearFromPathNormativities}) and ${filtersArray}`;
                    styles = mapNormativityFlag ? 'MADiagSegmentNormativityAllGreens' : 'MADiagSegmentNormativityAllReds'
                }
            } else if (type === 'RoadAccidents') {
                layerURL = 'MARoadAccidentForFilters'
            }
            layersNames = layersNames?.replace('MC', 'MA')
            const view = map.getView();
            const viewResolution = view.getResolution();
            const viewProjection = view.getProjection();
            if (layer) {
                let url = layer.getSource()?.getFeatureInfoUrl(
                    event.coordinate,
                    viewResolution,
                    viewProjection,
                    getFeatureURLParamsObject({
                        VERSION: wmsVersion,
                        LAYERS: layersNames,
                        CQL_FILTER: cqlFilter,
                        styles,
                        propertyName: featurePropsForMapTooltip[propsType] ?? null,
                        buffer: null
                    })
                )
                const urlParts = url?.split('?');
                if (urlParts?.length === 2) {
                    if (url) {
                        fetch(url)
                            .then((response) => response.json())
                            .then(async (data) => {
                                let properties: any;
                                const features = data?.features ?? [];
                                if (!features.length) throw new Error("В данной точке отсутствуют объекты");
                                const firstFeature = () => features[0];
                                const maxEventYearFeature = (arr: any[]) => findMaxEventYearFeature(arr);
                                switch (type) {
                                    case 'pathNormativities': {
                                        properties = firstFeature()?.properties;
                                        if (properties) {
                                            const { Position, Ending } = await getSegmentNormativityBounds(properties.InfoObjectID, properties.PathNormativityId, measureType, mapMultipleMeasureTypes) ?? {}
                                            properties = { ...properties, Position, Ending }
                                        }
                                        break;
                                    }
                                    case 'highwayNetworkSegments':
                                    case 'RoadWorkSegmentsPODD': {
                                        properties = firstFeature()?.properties;
                                        break;
                                    }
                                    case 'roadBedLayerSegments': {
                                        properties = firstFeature()?.properties;
                                        const { RoadbedTypeID } = properties ?? {}
                                        const RoadBedType = (Object.values(roadBedFiltersOptions) as Array<{ roadbedTypeId?: unknown, name?: string }>).find(value => value.roadbedTypeId == RoadbedTypeID)?.name;
                                        properties = { ...properties, RoadBedType }
                                        break;
                                    }
                                    case 'roadCategorySegments': {
                                        properties = firstFeature()?.properties;
                                        const { RelativeCategoryId } = properties ?? {}
                                        const RoadCategory = (Object.values(roadCategoryFiltersOptions) as Array<{ categoryId?: unknown, name?: string }>).find(value => value.categoryId == RelativeCategoryId)?.name;
                                        properties = { ...properties, RoadCategory, RoadCategoryId: RelativeCategoryId }
                                        break;
                                    }
                                    case 'RoadAccidents': {
                                        properties = firstFeature()?.properties;
                                        const { Position, RoadName, PathName } = properties ?? {}
                                        if (properties) {
                                            store.dispatch(setMapTooltipKm(Position?.toFixed(3)?.replace('.', ',')));
                                            store.dispatch(setMapTooltipRoadName(RoadName));
                                            store.dispatch(setMapTooltipPathName(PathName));
                                        }
                                        break;
                                    }
                                    case 'RoadAccidentSegments': {
                                        properties = firstFeature()?.properties
                                        properties = transformObjectWithEnums(properties)
                                        break;
                                    }
                                    case 'RoadDiagnosticsSegments':
                                    case 'RoadDiagnosticsSegmentsPassport': {
                                        properties = maxEventYearFeature(features)?.properties;
                                        break;
                                    }
                                    case 'TrafficIntensity': {
                                        properties = maxEventYearFeature(features)?.properties;
                                        break;
                                    }
                                    case 'RoadWorksWithNormativities': {
                                        const filteredFeatures = features.filter((feature: any) => feature?.id?.includes('Work'));
                                        const feature = maxEventYearFeature(filteredFeatures)
                                        const WorkState = feature?.id.includes('Planned') ? 'Запланировано' : 'Проведено';
                                        properties = feature?.properties;
                                        properties = { ...properties, WorkState }
                                        break;
                                    }
                                    default: {
                                        properties = firstFeature()?.properties;
                                    }
                                }
                                if (properties && typeof properties === 'object') {
                                    store.dispatch(setMapTooltipData(properties));
                                }
                                store.dispatch(setMapTooltipIsVisible(true))
                            })
                            .catch((error) => {
                                store.dispatch(setMapTooltipIsVisible(false))
                                store.dispatch(resetMapTooltipData())
                            })
                            .finally(() => {
                                store.dispatch(setMapTooltipInfoCopied(false))
                                store.dispatch(setMapTooltipIsLoading(false))
                            });
                    }
                }
            }
        } else {
            store.dispatch(setMapTooltipIsVisible(false))
            store.dispatch(resetMapTooltipData())
        }
    }, 150);
}

function checkValue(value: any) {
    let checkedValue = value != null && value !== '' ? value : "—"
    return checkedValue
}

// функция копирования данных из подсказки
export function copyInfoFromTooltip(measureType?: any) {
    const state = store.getState();
    const { mapTooltipIsVisible, tooltipRoadName, tooltipPathName, tooltipKm, data } = state.mapTooltip;
    if (!mapTooltipIsVisible) return;

    const displayData = formatObject(data) ?? {};
    const { Position, Ending, Begining, RoadCategory, RoadBedType } = displayData;
    const checkedRoadName = checkValue(tooltipRoadName);
    const checkedPathName = checkValue(tooltipPathName);
    const checkedKm = checkValue(tooltipKm);
    const checkedPosition = checkValue(Position ?? Begining);
    const checkedEnding = checkValue(Ending);

    const base = `Дорога: ${checkedRoadName}; Направление: ${checkedPathName}; Начало участка: ${checkedPosition}; Конец участка: ${checkedEnding}; Км: ${checkedKm}`;
    const tooltipType = window.location.pathname.split('/')[4];
    let extra = '';

    if (tooltipType === "PathNormativities") {
        if (measureType) {
            const v = (data as any)?.[measureType];
            const num = parseFloat(String(v ?? ''));
            const normativityFlag = !isNaN(num) && Boolean(num);
            extra = `Тип измерения: ${checkValue(shortMeasureTypesNames[measureType])}; Состояние: ${normativityFlag ? 'В нормативе' : 'Не в нормативе'}`;
        } else {
            const diag = state.diagnosticsPathNormativities ?? {};
            const chosen = diag.pathNormativitiesMapMultipleMeasureTypes ?? {};
            const active = Object.keys(chosen).filter(k => chosen[k]).map(k => shortMeasureTypesNames[k]);
            const normativityFlag = diag.pathNormativitiesMapNormativityFlag;
            extra = `Типы измерений: ${active.length ? active.join(', ') : "-"}; Состояние: ${normativityFlag ? 'В нормативе' : 'Не в нормативе'}`;
        }
    }

    if (tooltipType === "RoadBedLayerSegments") {
        extra = `Тип дорожной одежды: ${checkValue(RoadBedType)}`;
    }

    if (tooltipType === "RoadCategorySegments") {
        extra = `Категория дороги: ${checkValue(RoadCategory)}`;
    }

    const copyInfoText = [base, extra].filter(Boolean).join('; ');

    navigator.clipboard.writeText(copyInfoText).catch(err => {
        console.error('Ошибка копирования', err);
    });

    store.dispatch(setMapTooltipInfoCopied(true));
}
